// @flow

import type { ProductSummary } from 'src/modules/mailbox-standalone/resources/products';

import { useProductsFetch } from '../../../modules/hooks/useProductsFetch';

import { BillingChoice } from './BillingChoice';

import { DeleteChoice } from './DeleteChoice';
import { QuantityChoice } from './QuantityChoice';
import { SummaryChoice } from './SummaryChoice';
import { SummaryChoiceSkeleton } from './SummaryChoiceSkeleton';

import styles from './ProductChoice.scss';

const FORM_ID = 'mailbox-standalone-create';
const productType = { productType: 'mailbox-standalone' };
const SKELETON_COUNT = 2;

export const ProductChoice = (): React.MixedElement => {
  const { summaries: products, isFetching } = useProductsFetch();

  if (isFetching) {
    return (
      <>
        {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className={styles.productChoiceContainer}>
            <SummaryChoiceSkeleton />
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {products?.map((product: ProductSummary) => {
        return (
          <div
            key={product.config_name}
            className={styles.productChoiceContainer}
          >
            <SummaryChoice product={product} FORM_ID={FORM_ID} />
            <DeleteChoice product={product} productType={productType} />

            <BillingChoice product={product} productType={productType} />
            <QuantityChoice productType={productType} product={product} />
          </div>
        );
      })}
    </>
  );
};
